import React from 'react';
import { NavLink } from 'react-router-dom';
import './css/NavBox.css';

const navItems = [
    // { id: 1, label: 'Эрдэнэт ХБАХТ', path: 'news-information/local' },
    { id: 2, label: 'Мэдээ', path: 'news-information/news' },
    { id: 3, label: 'Статистик', path: 'news-information/statistic' },
];

const QaNavBox: React.FC = () => {


    return (
        <div className="nav-box">
            {navItems.map((item) => (
                <NavLink
                    key={item.id}
                    to={`/${item.path}`}
                    className={({ isActive }) =>
                        `nav-item ${isActive ? 'nav-item--active' : ''}`
                    }
                >
                    <span>{item.label}</span>
                    <span className="nav-icon">⮕</span>
                </NavLink>
            ))}
        </div>
    );
};

export default QaNavBox;